import styled from 'styled-components';

const BrandCardAmountsContainer = styled.div`
    display: flex;
    flex-direction: row;
`;

export default BrandCardAmountsContainer;
